<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div class="" style="padding-top: 77px;">
              <!-- Nav tabs -->
              <h2 class="listing-page-title">Claim Listing</h2>
              <p class="listing-page-desc" style="text-transform: capitalize;">{{ MajorClass ? MajorClass.replace(/_/g," ") : '' }}</p>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>
      <div class="container multistep-box" style="margin: 50px auto 20px; text-align: center;">
        <div class="row mb-4">
          <div class="col-12 ib-border-b">
            <div class="d-flex in-risk-title-dropdown">
              <div class="mb-3 mb-md-0">
                <h1 class="ib-claim-listing text-capitalize in-title-risk-mb--fix">Claim Listing</h1>
              </div>
            </div>
            <ul class="list-inline">
<!--              <li class="mb-3 mb-md-0"><h1 class="ib-claim-listing">Claim Listing</h1></li>-->
              <form action="" class="float-md-right ml-0 ml-md-auto list-position text-left text-md-center">
                <li class="list-inline-item">
                      <div class="in-risk-title-dropdown in-risk-title-dropdown--fix">
                        <select style="width: 100% !important;" class="floating-select in-dropdown-per-page" @change="onChange($event)">
                          <option value="5">5</option>
                          <option value="10" selected>10</option>
                          <option value="20">20</option>
                        </select>
                        <span class="highlight"></span>
                        <div class="ib-custom-select"></div>
                      </div>
                    </li>
                <li class="list-inline-item">
                  <ul class="list-inline">
                    <li class="list-inline-item">
                      <div class="jbl-field in-search-field">
                        <input type="text" id="texto" class="jbl-dynamic-input" placeholder="Search here..." v-on:keyup="filterSearch" v-model="searchFilter"/>
                      </div>
                    </li>
                    <li class="list-inline-item">
                      <div class="field jbl-responsive-btn">
                        <router-link :to="{ name: 'AddClaim' }" class="ib-btn-primary ib-btn-width ib-btn-hover">ADD CLAIM</router-link>
                      </div>
                    </li>
                  </ul>
                </li>
              </form>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="listing-nav">
              <div class="d2c-main-classes">
                <button class="d2c-class-btn" :class="MajorClass == major_class ? 'active' : ''" v-for="(major_class, key) in major_classes" @click="LoadClaims(major_class)">
                  <div class="in-right-border" style="text-transform: capitalize;">
                    {{  major_class.replace(/_/g," ") }}
                  </div>
                </button>
              </div>
            </div>
          </div>
           <!-- d-none d-md-block -->
          <div class="col-md-12 d-none d-md-block">
            <table class="claim-listing">
              <tbody>
                <tr v-for="self_claim in dispalyItems" :key="self_claim.id" @click="viewClaim(self_claim.id)">
                  <td class="jbl-responsive-td data-img">
                    <div class="in-listing-img">
                      <img alt="icon" class="img-fluid" :src="self_claim.plan_image" v-if="self_claim.plan_name !== ''" />
                      <img alt="icon" class="img-fluid" :src="self_claim.product_image" v-else />
                      <div class="position-relative-box">
                        <img alt="icon" class="img-fluid small-icon" :src="self_claim.company_logo_path" />
                      </div>
                    </div>
                  </td>
                  <td v-if="self_claim.plan_name !== ''" class="jbl-table-heading jbl-responsive-td">{{ self_claim.subclass_name }}
                    <small>{{ self_claim.product_name }}</small>
                    <small class="ib-card-plan">{{ self_claim.plan_name }}</small>
                  </td>
                  <td v-else class="jbl-table-heading jbl-responsive-td">{{ self_claim.subclass_name }}
                    <small  class="ib-card-plan">{{ self_claim.product_name }}</small>
                  </td>
                  <td class="jbl-responsive-td">
                    <div class="jbl-flex-td">
                      <div class="jbl-date-td jbl-date-heading">Policy No</div>
                      <div class="jbl-date-td">{{ self_claim.policy_no}}</div>
                    </div>
                  </td>
                  <td class="jbl-responsive-td">
                    <div class="jbl-flex-td">
                      <div class="jbl-date-td jbl-date-heading">Claim No</div>
                      <div class="jbl-date-td">{{ self_claim.claim_no}}</div>
                    </div>
                  </td>

                  <td class="jbl-responsive-td">
                    <div class="jbl-flex-td">
                      <div class="jbl-date-td jbl-date-heading">Intimation Date</div>
                      <div class="jbl-date-td">{{ formatDate(self_claim.created_at) }}</div>
                    </div>
                  </td>
                  <td class="jbl-responsive-td">
                    <div class="jbl-flex-td">
                      <div class="jbl-date-td jbl-date-heading">Status</div>
                      <div class="ib-status" :class=" self_claim.status +'-status'">{{ self_claim.status }}</div>
                    </div>
                  </td>
                  <td class="jbl-responsive-td in-w-60">
                    <router-link :to="{ name: 'ClaimsView', params: { id: self_claim.id } }" class="nex-Page-Link">
                      <!-- <i class="fa fa-chevron-right"></i> -->
                      <!-- <img class="img-fluid in-w-10" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon"> -->
                      <span style="float:right" ><i class="arrow_risk right1 feedback_arrow"></i></span>
                    </router-link>

                  </td>
                </tr>
              </tbody>
            </table>
            <h2 style="color: rgba(0, 0, 0, 0.3) !important;" v-if="self.length === 0">No Claim Found</h2>
          </div>

          <!-- mobile view -->
          <div class="col-md-12 d-md-none">
            <div class="d-flex in-sm-listing" v-for="self_claim in self" :key="self_claim.id" @click="viewClaim(self_claim.id)">
              <div class="in-sm-firstdiv">
                <div class="in-listing-img in-sm-height">
                  <img class="img-fluid" :src="self_claim.plan_image" v-if="self_claim.plan_name !== ''" />
                  <img class="img-fluid" :src="self_claim.product_image" v-else />
                  <div class="position-relative-box">
                  <img alt="icon" class="img-fluid small-icon" :src="self_claim.company_logo_path" />
                  </div>
                </div>
              </div>
              <div class="in-sm-flex1">
                <div class="d-flex in-sm-date">
                  <div>Intimation Date:&nbsp;</div>
                  <div>{{ formatDate(self_claim.created_at) }}</div>
                </div>
                <div class="in-sm-title"  v-if="self_claim.plan_name !== ''">{{ self_claim.subclass_name }}
                  <small>{{ self_claim.product_name }}</small>
                  <small class="ib-card-plan">{{ self_claim.plan_name }}</small>
                </div>
                <div class="in-sm-title" v-else>{{ self_claim.subclass_name }}
                  <small class="ib-card-plan">{{ self_claim.product_name }}</small>
                </div>
                <div>
                  <div class="d-flex">
                    <div class="in-sm-property">Claim No</div>
                    <div class="in-sm-value">{{ self_claim.claim_no}}</div>
                  </div>
                </div>
                <div class="">
                  <div class="d-flex">
                    <div class="in-sm-value ib-td-currency">PKR <span>{{ priceFormatter(self_claim.paid_amount) }}</span></div>
                  </div>
                </div>
                  <div class="in-sm-status ib-status" :class=" self_claim.status +'-status'">{{ self_claim.status }}</div>
              </div>
            </div>
          </div>
          <!-- mobile view -->
          <PaginationComponent v-if="isShowing" @updatePage="changePage" @updatedData="getName"  :chunkSize="chunkSize" :customer_self_policies_filterd="customer_self_policies_filterd" :isShowing="isShowing"/>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import loading from '@/components/Loading/Loading'
  import PaginationComponent from "../../components/PaginationComponent";

  import moment from "moment";

  export default {
    name: 'Claims',
    components: {
      loading,
      PaginationComponent

    },
    data () {
      return {
        showLoader: false,
        self_claims: {},
        nominated_claims: {},
        self: {},
        nominated: {},
        customer_self_policies_filterd:{},
        self_claim_area: true,
        nominated_claim_area: false,
        current_state: 'self',
        major_classes: {},
        first_class: '',
        MajorClass: '',
        searchFilter: '',
        pageOfItems:{},
        dispalyItems:[],
        currentPage:0,
        name:'',
        isShowing : true,
        chunkSize: 10,

      };
    },
    created: function () {
      const self = this;
      self.getData();
    },
    methods: {
      onChange(e){
        const self =this;
        self.chunkSize = parseInt(e.target.value);
      },
      priceFormatter(price) {
        return new Intl.NumberFormat('en-PK').format(price);
      },
      formatDate(date) {
        return moment(date, "YYYY-MM-DD").format('DD-MMM-YYYY');
      },
      getName(name){
        this.dispalyItems = name;
      },
      changePage(value){
        this.currentPage = value;
      },
      async getData() {
        var self = this;
        const promises = [];

        self.showLoader = true;
        // promises.push(await axios.get('get_mainclasses').then(function (resp) {
        //   if (resp.data.code == 200) {
        //     self.first_class = resp.data.data.main_classes[0];
        //     self.major_classes = resp.data.data.main_classes;
        //     self.MajorClass = self.first_class.name;
        //   } else {
        //     self.showLoader = false;
        //     $toast.error(resp.data.message, { position: 'top-right' });
        //     return false;
        //   }
        // }).catch(function (error) {
        //   self.showLoader = false;
        //   if(error.data.errors != undefined) {
        //     error.data.errors.forEach(element => {
        //       $toast.error(element.message, { position: 'top-right' });
        //     });
        //   } else {
        //     $toast.error(error.data.message, { position: 'top-right' });
        //   }
        // }));

        promises.push(await axios.get('customer/claims').then(function (resp) {
          if (resp.data.code == 200) {
            self.self_claims = resp.data.data.self_policies_claims;
            self.self = resp.data.data.self_policies_claims;
            self.customer_self_policies_filterd = resp.data.data.self_policies_claims;

            let main_classes = [];
            self.self_claims.forEach(element => {
              main_classes.push(element.mainclass_name);
            });
            let filtered_main_classes = main_classes.filter((item, i, ar) => ar.indexOf(item) === i);
            self.major_classes = filtered_main_classes;
            self.MajorClass = filtered_main_classes[0];

            self.LoadClaims(self.MajorClass);
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        }));

        Promise.all(promises).then(() => {
          self.showLoader = false;
        });
      },
      LoadClaims(class_name) {
        const self = this;
        self.self = {};
        self.MajorClass = class_name;
        if(self.searchFilter != '') {
          self.customer_self_policies_filterd = self.self_claims.filter(x => x.mainclass_name.replace(/ /g,"_").toLowerCase() == class_name.replace(/ /g,"_").toLowerCase() && (x.product_name.toLowerCase().includes(self.searchFilter.toLowerCase())
            || x.subclass_name.toLowerCase().includes(self.searchFilter.toLowerCase())
            || x.status.toLowerCase().includes(self.searchFilter.toLowerCase())
            || x.claim_no.includes(self.searchFilter.toLowerCase())
            || x.policy_no.includes(self.searchFilter.toLowerCase())));
        } else {
          self.customer_self_policies_filterd = self.self_claims.filter(x => x.mainclass_name.replace(/ /g,"_").toLowerCase().includes(class_name.replace(/ /g,"_").toLowerCase()));
        }
      },
      filterSearch() {
        const self = this;
        self.self = {};
        let class_name = self.MajorClass.replace(/ /g,"_").toLowerCase();

        if(self.MajorClass != '') {
          if(self.current_state == 'self') {
            self.self = self.self_claims.filter(x => x.mainclass_name.replace(/ /g,"_").toLowerCase() == class_name && (x.product_name.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.subclass_name.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.status.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.claim_no.includes(self.searchFilter.toLowerCase())
              || x.policy_no.includes(self.searchFilter.toLowerCase())));
          } else {
            self.nominated = self.nominated_claims.filter(x => x.mainclass_name.replace(/ /g,"_").toLowerCase() == class_name && (x.product_name.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.subclass_name.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.status.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.claim_no.includes(self.searchFilter.toLowerCase())
              || x.policy_no.includes(self.searchFilter.toLowerCase())));
          }
        } else {
          if(self.current_state == 'self') {
            self.self = self.self_claims.filter(x => x.mainclass_name.replace(/ /g,"_").toLowerCase() == class_name && (x.product_name.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.subclass_name.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.status.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.claim_no.includes(self.searchFilter.toLowerCase())
              || x.policy_no.includes(self.searchFilter.toLowerCase())));
          } else {
            self.nominated = self.nominated_claims.filter(x => x.mainclass_name.replace(/ /g,"_").toLowerCase() == class_name && (x.product_name.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.subclass_name.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.status.toLowerCase().includes(self.searchFilter.toLowerCase())
              || x.claim_no.includes(self.searchFilter.toLowerCase())
              || x.policy_no.includes(self.searchFilter.toLowerCase())));
          }
        }
      },
      viewClaim (claimId) {
        const self = this;
        self.$router.push({ name: 'ClaimsView', params: { id: claimId } });
      }
    }
  };
</script>

<style scoped>
  .data-row p {
    color :#5b6770;
  }
  table > tbody > tr, .data-row {
    margin: 10px 0;
    padding: 20px 30.7px 20px 15px;
    border-radius: 10px;
    border: solid 1px #dedada;
    background-color: #ffffff;
  }
  .data-row .action-area {
    text-align: right;
  }
  .data-row .action-area i {
    width: 7.9px;
    height: 14.6px;
    color: #5b6770;
  }
  .data-row .claim-row-sub-heading {
    color: #a9adaf;
  }
  .data-row .claim-row-sub-desc {
    color: #5b6770;
  }
  .data-row .status-danger {
    background-color: rgba(30, 203, 16, 0.09);
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    color: #1ecb10;
    letter-spacing: normal;
  }
  .data-row .status {
    margin: 10px 61.3px 10px 52px;
    padding: 6px 24px;
    border-radius: 6px;
    font-family: "Futura PT";
  }
  .data-row .claim-row-data {
    font-family: "Futura PT";
    font-size: 17px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 8px;
    letter-spacing: normal;
    text-align: left;
  }
  .data-row .claim-row-heading {
    font-family: "Futura PT";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  /* table > tbody > tr > th > img,.data-img img {
    width: 79px;
    height: 66px;
    border-radius: 11px;
    border: 1px solid gainsboro;
  }
  .position-relative .small-icon {
    border-radius: 50%;
    position: absolute;
    width: 25px;
    height: 25px;
    top: -20px;
    right: 0px;
  } */
  .in-listing-img {
    width: 79px;
    height: 66px;
    background-color: #ecf3f5;
    border-radius: 11px;
    border: 1px solid gainsboro;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 12px;
  }
   .in-listing-img img{
    width: 100% !important;
    max-width: 70px !important;
    max-height: 60px !important;
    height: auto !important;
  }

  .position-relative-box {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid gainsboro;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: absolute;
    bottom: -10px;
    right: -10px;
  }
   .position-relative-box img{
    width: 100% !important;
    max-width: 23px !important;
    height: auto !important;
  }
  table.claim-listing {
    width: 100%;
    margin: 0 auto;
    font-family: Arial, sans-serif;
    border-collapse: separate;
    border-spacing: 0 10px;
  }
  table.claim-listing td {
    height: 100px !important;
    vertical-align: middle;
    text-align: center;
    position: relative;
  }
  @media (max-width:668px) {
    table.claim-listing td:not(:first-child) {
      height: 60px !important;
    }
    table.claim-listing tbody td:first-child {
      height: auto !important;
    }
  }
  table.claim-listing td:last-child:after {
    content: none;
  }
  table.claim-listing tbody td {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }
  @media (min-width:669px) {
    table.claim-listing tbody td:first-child {
    border-left: 1px solid #eee;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    }
    table.claim-listing tbody td:last-child {
      border-right: 1px solid #eee;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    table.claim-listing tbody tr {
      box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
    }
  }
  .jbl-table-heading {
    font-family: "Avenir Medium";
    font-weight: 500;
    text-align: left !important;
    font-size: 19px;
    color: #5b6770;
  }
  @media (min-width: 1200px){
    .jbl-table-heading {
      max-width: calc(580px - 100px);
    }
    .jbl-date-td {
    font-size: 16px !important;
    }
  }
  /* .jbl-table-heading span {
    font-size: 19px;
    font-size: 10px;
    color: #5b6770;
    font-weight: normal !important;
  } */
   .jbl-table-heading span {
    font-weight: normal !important;
    font-size: 10px !important;
    font-weight: 500 !important;
    color: #ef7c94 !important;
  }
  .jbl-table-heading small {
    font-weight: normal !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    color: #ef7c94 !important;
  }
  .jbl-date-td {
    font-family: "Avenir Medium";
    font-size: 19px;
    font-weight: 500;
    text-align: left;
    color: #5b6770;
  }
  .jbl-date-heading {
    color: #ef7c94 !important;
    font-family: "Avenir Book";
    font-size: 13px;
    text-align: left;
  }
  table.claim-listing .fa-chevron-right {
    padding-right: 2rem;
    color: #5b6770;
  }
  .jbl-flex-td {
    display: flex;
    flex-direction: column;
  }
  @media (min-width:668px) and (max-width:992px) {
    .jbl-table-heading {
      font-size: 14px;
    }
    .jbl-date-td {
      font-family:"Futura PT Medium";
      font-size: 12px;
    }
    table.claim-listing .fa-chevron-right {
      padding-right: 1rem;
      color: #5b6770;
    }
  }
  .d2c-main-classes {
    background-color: #def3f7;
    border-radius: 31px;
    max-width: fit-content;
    margin: 1px 0 30px;
  }
  .d2c-class-btn {
    display: inline-block;
    margin-bottom: 0;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: nowrap;
    padding: 6px 12px;
    border: 1px solid transparent;
    border-radius: 4px;
    height: 61px;
    margin: 0 0 1px;
    border-radius: 31px;
    background-color: #def3f7;
    font-family: "Avenir Medium";
    font-size: 16px;
    font-weight: 500;
    line-height: 1.38;
    color: #4c505d;
    transition: all .3s ease-in;
  }
  .d2c-class-btn:hover {
    background-color: #049cbd;
    color: white;
  }
  .d2c-class-btn:focus, .d2c-class-btn:active, .d2c-class-btn.active {
    outline: none !important;
    background-color: #049cbd;
    color: white;
  }
  /* .d2c-main-classes .d2c-class-btn::after {
    content: '';
    width: 0;
    height: 35px;
    border: solid 1px #049ab3;
    position: relative;
    right: -16px;
  }
  .d2c-main-classes.d2c-class-tabs button.d2c-class-btn::after {
    content: '';
    border: none !important;
  }
  .d2c-main-classes button:last-child.d2c-class-btn::after {
    content: '';
    border: none !important;
  } */
  .nex-Page-Link .fa-chevron-right {
    color: #aeccd6 !important;
    font-weight: normal !important;
  }
   @media(max-width:550px){
    .d2c-class-btn{
      padding: 6px 22px !important;
      width: max-content !important;
      font-size: 12px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Claims/Index.vue